import React from 'react';
import {EmailLogList} from "components/email-log/EmailLogList";
import {Provider} from "components/email-log/EmailLogContext";

export const EmailLogs = () => {

    return (
        <Provider>
            <EmailLogList/>
        </Provider>
    );
}
